// basado de https://onthecode.co.uk/force-selection-angular-material-autocomplete/
import { AbstractControl } from '@angular/forms';
 
export function RequireMatchValidator (control: AbstractControl) {
    const selection: any = control.value;
    if (typeof selection === 'string') {
        return { incorrect: true };
    }
    return null;
}